import { render, staticRenderFns } from "./Profession.vue?vue&type=template&id=66ba6e60&"
import script from "./Profession.vue?vue&type=script&lang=js&"
export * from "./Profession.vue?vue&type=script&lang=js&"
import style0 from "./Profession.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports